module.exports = __webpack_public_path__ + "static/media/content-step4.5a720cd9.png";